import { useCallback, useEffect, useState } from "react";
import type { ProductionReferenceData, TerminalAdministration } from "../models";
import { productionGateway } from "../production-gateway";
import { today } from "../production-time";
import { useActiveShift } from "../useActiveShift";
import type { ProductionWorkspaceProps } from "../production-workspace-contract";

export function useSystemAdministratorWorkspace(props: Pick<ProductionWorkspaceProps, "notify" | "dataRefreshVersion">) {
  const [reference, setReference] = useState<ProductionReferenceData | null>(null);
  const [terminalAdmin, setTerminalAdmin] = useState<TerminalAdministration | null>(null);
  const [loading, setLoading] = useState(true);
  const [assignmentOpen, setAssignmentOpen] = useState(true);
  const shiftCode = useActiveShift();
  const refresh = useCallback(async () => {
    try {
      const [nextReference, nextAdministration] = await Promise.all([
        productionGateway.referenceData(today()),
        productionGateway.terminalAdministration(),
      ]);
      setReference(nextReference);
      setTerminalAdmin(nextAdministration);
    } catch (error) {
      props.notify(error instanceof Error ? error.message : "Makine atama yönetimi yüklenemedi.");
    } finally {
      setLoading(false);
    }
  }, [props.notify]);
  useEffect(() => { void refresh(); }, [props.dataRefreshVersion, refresh]);
  return { reference, terminalAdmin, loading, assignmentOpen, setAssignmentOpen, shiftCode, refresh };
}
